import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_layout/(private)/providers/$id/workers/create',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_layout/(private)/providers/$id/workers/create"!</div>;
}
